export default "__VITE_ASSET__47d52aa6__"